import { render, staticRenderFns } from "./MemberFeebackComponent.vue?vue&type=template&id=6bc3eeac&scoped=true&"
import script from "./MemberFeebackComponent.vue?vue&type=script&lang=js&"
export * from "./MemberFeebackComponent.vue?vue&type=script&lang=js&"
import style0 from "./MemberFeebackComponent.vue?vue&type=style&index=0&id=6bc3eeac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc3eeac",
  null
  
)

export default component.exports